import { ApiFieldShort } from "@/types/custom-field.types";
import { ApiEmployeeShort } from "@/types/employees/employee.types";
import { ModalProps } from "@skailer-com/uikit";

export enum HiringFlowTab {
  main = "main",
  personal = "personal",
  onboarding = "onboarding",
}

export enum HiringFlowSectionType {
  position = "position",
  employment = "employment",
  compensation = "compensation",
  employee_basic_info_manager = "employee_basic_info_manager",
  employee_basic_info_personal = "employee_basic_info_personal",
  employee_basic_info_contacts = "employee_basic_info_contacts",
  employee_basic_info_address = "employee_basic_info_address",
  employee_basic_info_hired_via_job = "employee_basic_info_hired_via_job",
  custom = "custom",
}

export interface ApiHiringFlowField {
  field: ApiFieldShort;
  is_enabled: boolean;
  is_mandatory: boolean;
}

export interface ApiHiringFlowSection {
  section_type: HiringFlowSectionType;
  title: string | null;
  fields: ApiHiringFlowField[];
}

export interface ApiHiringFlowOnboarding {
  probation_is_enabled: boolean;
  probation_is_mandatory: boolean;
  probation_policy_id: number | null;
  probation_policy_locked: boolean;
  compensation_after_probation_is_enabled: boolean;
  compensation_after_probation_is_mandatory: boolean;
  workflows_is_enabled: boolean;
  workflows_is_mandatory: boolean;
  workflow_ids: number[];
  workflows_locked: boolean;
}

export interface ApiHiringFlow extends ApiHiringFlowOnboarding {
  id: number;
  title: string;
  owner: ApiEmployeeShort | null;
  is_default: boolean;
  form: Record<HiringFlowTab.main | HiringFlowTab.personal, ApiHiringFlowSection[]>;
  datetime_updated_at: Date;
}

export interface ApiHiringFlowCreate {
  title: string;
  copy_from_id: number | null;
}

export interface ApiHiringFlowUpdate extends ApiHiringFlowOnboarding {
  title: string;
  is_default: boolean;
  form: Record<
    HiringFlowTab.main | HiringFlowTab.personal,
    {
      section_type: HiringFlowSectionType;
      title: string | null;
      fields: { slug: string; is_enabled: boolean; is_mandatory: boolean }[];
    }[]
  >;
}

export interface HiringFlowEditorSection extends ApiHiringFlowSection {
  key: string;
}

export interface HiringFlowSectionModalProps extends ModalProps {
  initialTitle?: string | null;
  sectionType?: HiringFlowSectionType;
  onSave: (title: string | null) => void;
}
